export const DETAIL_GET_COMMENT_LIST_REQUEST = 'DETAIL_GET_COMMENT_LIST_REQUEST';
export const DETAIL_GET_COMMENT_LIST_SUCCESS = 'DETAIL_GET_COMMENT_LIST_SUCCESS';
export const DETAIL_GET_COMMENT_LIST_FAILURE = 'DETAIL_GET_COMMENT_LIST_FAILURE';

export const DETAIL_GET_GRADE_REQUEST = 'DETAIL_GET_GRADE_REQUEST';
export const DETAIL_GET_GRADE_SUCCESS = 'DETAIL_GET_GRADE_SUCCESS';
export const DETAIL_GET_GRADE_FAILURE = 'DETAIL_GET_GRADE_FAILURE';

export const DETAIL_ADD_COMMENT_REQUEST = 'DETAIL_ADD_COMMENT_REQUEST';
export const DETAIL_ADD_COMMENT_SUCCESS = 'DETAIL_ADD_COMMENT_SUCCESS';
export const DETAIL_ADD_COMMENT_FAILURE = 'DETAIL_ADD_COMMENT_FAILURE';

export const DETAIL_ADD_ZAN_REQUEST = 'DETAIL_ADD_ZAN_REQUEST';
export const DETAIL_ADD_ZAN_SUCCESS = 'DETAIL_ADD_ZAN_SUCCESS';
export const DETAIL_ADD_ZAN_FAILURE = 'DETAIL_ADD_ZAN_FAILURE';

export const USER_SCORE_FORSTORE_REQUEST = 'USER_SCORE_FORSTORE_REQUEST';
export const USER_SCORE_FORSTORE_SUCCESS = 'USER_SCORE_FORSTORE_SUCCESS';
export const USER_SCORE_FORSTORE_FAILURE = 'USER_SCORE_FORSTORE_FAILURE';
